import { useStyles } from './SampleAssessmentPill.styles';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import TooltipOne from '../TooltipOne/TooltipOne.component';
import { AssessmentQuality } from '../../models/assessment.types';
import { getColor } from '../../utils/assessmentQuality';
import { AssessmentSessionProcessTypeId } from '../../services/exams/assessmentSession/assessments.types';

interface SampleAssessmentPillProps {
  sampleAssessmentPoints: number | null;
  assessmentQuality: AssessmentQuality | null;
  processTypeId: AssessmentSessionProcessTypeId;
  sampleAssessmentSum?: number;
  tooltip?: string;
  color?: string;
  label?: string;
}

export const SampleAssessmentPill: React.FC<SampleAssessmentPillProps> = (props) => {
  const classes = useStyles();
  const color = props.color ? props.color : getColor(props.assessmentQuality, props.processTypeId);

  const getIcon = (): JSX.Element => {
    switch (props.assessmentQuality) {
      case AssessmentQuality.Accurate:
        return <DoneIcon style={{ color: color }} fontSize="small" />;

      case AssessmentQuality.Inaccurate:
        return <CloseIcon style={{ color: color }} fontSize="small" />;

      case AssessmentQuality.WithinTolerance:
        return props.processTypeId === AssessmentSessionProcessTypeId.Training ? (
          <CloseIcon style={{ color: color }} fontSize="small" />
        ) : (
          <PriorityHighIcon style={{ color: color }} fontSize="small" />
        );

      default:
        return <></>;
    }
  };

  return (
    <TooltipOne title={props.tooltip ? props.tooltip : ''} placement="top">
      <div
        className={classes.pillBase}
        style={{
          borderColor: props.color || props.assessmentQuality !== null ? color : 'transparent',
          color: color,
        }}
      >
        {props.label && <div className={classes.pillLabel}>{props.label}</div>}
        <div className={classes.points}>{props.sampleAssessmentPoints}</div>
        {props.sampleAssessmentSum !== undefined && <div>/{props.sampleAssessmentSum}</div>}
        {getIcon()}
      </div>
    </TooltipOne>
  );
};
